import { render, staticRenderFns } from "./InsightsPage.vue?vue&type=template&id=5ec39a4c&scoped=true&"
import script from "./InsightsPage.vue?vue&type=script&lang=js&"
export * from "./InsightsPage.vue?vue&type=script&lang=js&"
import style0 from "./InsightsPage.vue?vue&type=style&index=0&id=5ec39a4c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ec39a4c",
  null
  
)

export default component.exports